// Dynamic title routing
export const ChangeTitle = (currentPage) => {
  return (document.title = currentPage);
};
